import {usePoisIsochroneContext} from "poi/map";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Stack from "@mui/material/Stack";
import {theme} from "Theme";

import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import DirectionsBikeOutlinedIcon from "@mui/icons-material/DirectionsBikeOutlined";
import DirectionsWalkOutlinedIcon from "@mui/icons-material/DirectionsWalkOutlined";
import {createElement} from "react";
import {useMapContext} from "base/map";
import Typography from "@mui/material/Typography";

const options = [
    {label: "A pie", value: "walking", icon: DirectionsWalkOutlinedIcon},
    {label: "Bici", value: "cycling", icon: DirectionsBikeOutlinedIcon},
    {label: "Coche", value: "driving", icon: DirectionsCarFilledOutlinedIcon},
];

const IsocronasMapTransportAction = () => {
    const {selectedTransport: selectedOption, setSelectedTransport: setSelectedOption} =
        usePoisIsochroneContext();
    const {selectedPoint} = useMapContext();

    const handleOption = (event, value) => {
        console.log({value});
        setSelectedOption(value);
    };

    return (
        <Stack
            justifyContent="flex-start"
            alignItems="center"
            direction="row"
            spacing={1}
        >
            <Typography variant="caption" sx={{fontSize: 10, whiteSpace: "wrap"}}>
                Transporte
            </Typography>
            <ToggleButtonGroup
                value={selectedOption}
                exclusive
                onChange={handleOption}
                aria-label="selector de transporte"
                size="small"
                sx={{flex: 1}}
            >
                {options.map(option => (
                    <ToggleButton
                        key={option.value}
                        value={option.value}
                        aria-label={`${option.label}`}
                        sx={{
                            color:
                                selectedPoint && !selectedOption
                                    ? theme.palette.warning.light
                                    : "inherit",
                            backgroundColor: "white",
                            "&.Mui-selected": {
                                backgroundColor: "#2e85cb",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#2e85ee",
                                },
                            },
                            "&.MuiToggleButtonGroup-middleButton, &.MuiToggleButtonGroup-lastButton":
                                {
                                    borderLeft: "1px solid lightgrey",
                                },
                        }}
                    >
                        {createElement(option.icon, {
                            fontSize: "small",
                        })}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Stack>
    );
};

export default IsocronasMapTransportAction;
